var _g, _path, _path2, _path3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgComplianceDocxFileExpired = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 47,
  height: 51,
  viewBox: "0 0 47 51",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
  filter: "url(#25p5deftra)"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M3.313 1h29.989l11.466 11.992V46.63c0 .72-.558 1.303-1.247 1.303H3.313c-.688 0-1.246-.583-1.246-1.303V2.304c0-.72.558-1.304 1.246-1.304z",
  fill: "#F0EFEF"
}))), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M33.794 1.514 45.26 13.506H35.04c-.688 0-1.246-.584-1.246-1.304V1.514z",
  fill: "#ABABAB"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M30.677 16.933H15.922c-1.062 0-1.922.86-1.922 1.922v14.716c0 1.062.86 1.922 1.922 1.922h14.755c1.062 0 1.922-.86 1.922-1.922V18.855c0-1.061-.86-1.922-1.922-1.922z",
  fill: "#ABABAB"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M20.57 29.172c.028.205.046.384.055.537h.03c.013-.145.038-.32.073-.525a8.4 8.4 0 0 1 .104-.52l1.457-6.044h1.885l1.507 5.954c.076.294.138.668.189 1.123h.025a8.31 8.31 0 0 1 .157-1.087l1.206-5.99h1.715l-2.11 8.66h-2.005l-1.438-5.737c-.042-.166-.09-.38-.142-.647a7.104 7.104 0 0 1-.097-.58h-.025c-.017.142-.05.351-.097.629-.049.278-.087.483-.117.616l-1.35 5.718h-2.035l-2.13-8.659h1.746l1.313 6.057c.03.124.058.29.085.495l2.63-5.024z",
  fill: "#fff"
})), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "25p5deftra",
  x: 0.067,
  y: 0,
  width: 46.701,
  height: 50.933,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 1
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 1
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.300721 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_389_478"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "effect1_dropShadow_389_478",
  result: "shape"
})))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgComplianceDocxFileExpired);
export default ForwardRef;